(() => {
  angular
    .module('gm.common.directives')
    .directive('gmDisableClick', gmDisableClickDirective);

  function preventBubble(event) {
    event.stopPropagation();
    event.preventDefault();
    event.returnValue = false;
    return false;
  }

  function gmDisableClickDirective() {
    'ngInject';

    return {
      restrict: 'A',
      scope: {
        gmDisableClick: '='
      },
      link(scope, element) {
        function bindClick(event) {
          if (scope.gmDisableClick) {
            return preventBubble(event);
          }
          return true;
        }

        element.bind('click', bindClick);

        scope.$on('$destroy', () => {
          element.unbind('click', bindClick);
        });
      },
    };
  }
})();
